import { theme } from '../../utility';

export const invoiceStatusColors = {
  open: theme.colors.green,
  'pre-approval': theme.colors.orange,
  draft: theme.colors.grey,
};

export const invoiceStatusText = {
  open: 'Open',
  'pre-approval': 'Pending Approval',
  draft: 'Draft',
};
